import { IStyle } from '@fluentui/react';

export interface IIngestOnlineStyles {
  root?: IStyle;
  messageBar?: IStyle;
  pivotItem?: IStyle;
}

export interface IIngestOnlineClassNames {
  root: string;
  messageBar: string;
  pivotItem: string;
}

export const ingestOnlineStylesDefault: Partial<IIngestOnlineStyles> = {
  root: {
    height: '100%',
  },
  messageBar: { position: 'absolute', zIndex: 1, right: '0px', top: '-81px' },
  pivotItem: {
    paddingTop: '8px',
    height: '100%',
    position: 'relative',
  },
};
